document.addEventListener("DOMContentLoaded", function () {
  const copyButtons = document.querySelectorAll(".share-button__copy");
  const shareButtons = document.querySelectorAll(".sharebutton-mobile");
  copyButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const shareSection = button.closest(".share--button");
      const inputField = shareSection.querySelector(".field__input");
      const shareMessage = shareSection.querySelector(".share-button__message");
      const shareFallback = shareSection.querySelector(".share-button__fallback");

      inputField.select();
      inputField.setSelectionRange(0, 99999);

      navigator.clipboard
        .writeText(inputField.value)
        .then(() => {
          // Show copy success message
          shareMessage.textContent = "URL copied to clipboard!";
          shareMessage.classList.remove("hidden");
          shareFallback.classList.add("active");
          setTimeout(() => {
            shareFallback.classList.remove("active");
          }, 5000);
        })
        .catch((err) => console.error("Error copying to clipboard:", err));
    });
  });

  // Native mobile share functionality
  shareButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const shareUrl = button.getAttribute("data-share-url");

      if (navigator.share) {
        navigator
          .share({
            title: document.title,
            url: shareUrl,
          })
          .catch((err) => console.error("Error sharing:", err));
      } else {
        // Show fallback when Web Share API is not supported
        alert("Sharing not supported on this device.");
      }
    });
  });
});
